module.exports.dritan = require('./DRITAN.svg');
module.exports.dyneema = require('./DYNEEMA.svg');
module.exports.goretex_surround = require('./GORETEX_SURROUND.svg');
module.exports.goretex = require('./GORETEX.svg');
module.exports.hm100k = require('./HM100K.svg');
module.exports.hydromax = require('./HYDROMAX.svg');
module.exports.michelin = require('./MICHELIN.svg');
module.exports.phorene = require('./PHORENE.svg');
module.exports.primaloft = require('./PRIMALOFT.svg');
module.exports.receptor = require('./RECEPTOR.svg');